<template>
    <multiselect
            v-model="receiptIssueDates"
            :options="memberReceiptIssueDatesOptions"
            track-by="key"
            label="value"
            :multiple="true"
            :allowEmpty="allowEmptyMultiselect"
            placeholder="Seleccione"
            selectedLabel=""
            selectLabel=""
            deselectLabel=""
            @input="notifyChange">
    </multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {memberReceiptIssueDatesOptions} from '@/constants/client-constants';

    export default {
        name: "ReceiptIssueDateMultipleSelector",
        components: {
            Multiselect
        },
        props: {
            value: Array,
            allowEmpty: Boolean
        },
        data: function () {
            return {
                receiptIssueDates: this.evaluateValue(this.value),
                allowEmptyMultiselect: !!this.allowEmpty,
            }
        },
        computed: {
            memberReceiptIssueDatesOptions() {
                return memberReceiptIssueDatesOptions;
            }
        },
        methods: {
            evaluateValue(value) {
                if (Array.isArray(value) && !!value.length) {
                    let array = [];
                    value.forEach((key) => {
                        if (!!key && !!this.findOptionByKey(key)) {
                            array.push(this.findOptionByKey(key));
                        }
                    });
                    return array;
                } else {
                    return [];
                }
            },
            findOptionByKey(key) {
                return memberReceiptIssueDatesOptions.find(option => (option.key === key));
            },
            notifyChange(selected) {
                this.$emit('input', selected.map(date => (date.key)));
            }
        },
        watch: {
            value: function () {
                this.receiptIssueDates = this.evaluateValue(this.value);
            }
        }
    }
</script>

<style scoped>

</style>
